/* global axios */
import ApiClient from './ApiClient';

class SummaryReportsAPI extends ApiClient {
  constructor() {
    super('summary_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getTeamReports({ since, until, businessHours, inboxId } = {}) {
    return axios.get(`${this.url}/team`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        inbox_id: inboxId,
      },
    });
  }

  getAgentReports({
    since,
    until,
    businessHours,
    inboxId,
    teamId,
    labelId,
  } = {}) {
    return axios.get(`${this.url}/agent`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        inbox_id: inboxId,
        team_id: teamId,
        label_id: labelId,
      },
    });
  }

  getInboxReports({ since, until, businessHours } = {}) {
    return axios.get(`${this.url}/inbox`, {
      params: {
        since,
        until,
        business_hours: businessHours,
      },
    });
  }

  getLabelReports({
    since,
    until,
    businessHours,
    inboxId,
    teamId,
    includeUnlabeled,
  } = {}) {
    return axios.get(`${this.url}/label`, {
      params: {
        since,
        until,
        business_hours: businessHours,
        inbox_id: inboxId,
        team_id: teamId,
        include_unlabeled: includeUnlabeled,
      },
    });
  }
}

export default new SummaryReportsAPI();
